import { ILanguagesGetResponse, Route, ILanguage, ILanguageGetQueryParameters } from "@edgetier/watchtower-types";
import { AxiosError } from "axios";
import { useQuery, UseQueryOptions } from "react-query";
import { axios } from "utilities/axios";

/**
 * Request the languages from the backend.
 * @returns An array of languages.
 */
const requestLanguages = async (parameters: ILanguageGetQueryParameters) => {
    const { data } = await axios.get<ILanguagesGetResponse>(Route.Languages, { params: parameters });
    return data.items;
};

/**
 * A query to request the languages from the backend.
 * @param configuration An optional query configuration.
 * @returns An array of languages.
 */
export const useLanguages = <T = ILanguage[]>(
    parameters: ILanguageGetQueryParameters = {},
    configuration: UseQueryOptions<ILanguage[], AxiosError, T> = {}
) => {
    return useQuery<ILanguage[], AxiosError, T>(
        [Route.Languages, parameters],
        () => requestLanguages(parameters),
        configuration
    );
};
